import {ComponentChildren, h} from 'preact'
import classNames from 'classnames'

type Props = {
  isDisabled: boolean,
  isChevron?: boolean,
  customClass?: string,
  children?: ComponentChildren,
  onClick?: (e: Event) => void
}

const Pager = ({ isDisabled, isChevron = false, onClick, children, customClass = '' }: Props) => {
  let options = {
    class: classNames(
      `control-pagination--pager-item`,
      isDisabled ? 'disabled' : null,
      isChevron ? 'chevron' : null,
      customClass
    ),
    onClick: !isDisabled ? onClick : undefined
  }
  return <div {...options} >{children}</div>
}

export default Pager
